import Footer from '../components/Footer/Footer'
import Headshotdetails from '../components/Headshot/Headshotdetails'
import Headshotheader from '../components/Headshot/Headshotheader'
import Headshotprice from '../components/Headshot/Headshotprice'
import Navbar from '../components/Navbar/Navbar'
import { metadata as headshotContent } from '../mdx/services/headshot.mdx'

const Headshotpage = () => {
  return (
    <div>
        <Navbar/>
        <Headshotheader content={headshotContent}/>
        <Headshotdetails/>
        <Headshotprice/>
        <Footer/>
    </div>
  )
}

export default Headshotpage
